import { useState, useEffect } from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Clock, LogOut } from 'lucide-react';
import { sessionSecurity } from '@/utils/sessionSecurity';
import { supabase } from '@/integrations/supabase/client';
import { TIMING } from '@/constants';

export const SessionTimeoutWarning = () => {
  const [showWarning, setShowWarning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    const checkTimeout = () => {
      if (sessionSecurity.shouldShowTimeoutWarning()) {
        setShowWarning(true);
        sessionSecurity.markWarningShown();
      }
      
      const remainingTime = Math.ceil(sessionSecurity.getTimeUntilTimeout() / 1000 / 60);
      setTimeLeft(remainingTime);
    };

    const interval = setInterval(checkTimeout, TIMING.SESSION_CHECK); // Check every 10 seconds
    checkTimeout(); // Initial check

    return () => clearInterval(interval);
  }, []);

  const extendSession = () => {
    sessionSecurity.updateActivity();
    setShowWarning(false);
  };

  const signOut = async () => {
    await supabase.auth.signOut();
    setShowWarning(false);
  };

  if (!showWarning || timeLeft <= 0) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 max-w-md">
      <Alert className="border-accent bg-accent/10">
        <Clock className="h-4 w-4 text-accent" />
        <AlertDescription className="text-accent">
          <div className="space-y-3">
            <p>Your session will expire in {timeLeft} minute{timeLeft !== 1 ? 's' : ''}.</p>
            <div className="flex gap-2">
              <Button 
                size="sm" 
                onClick={extendSession}
                className="bg-accent hover:bg-accent/80"
              >
                Stay Logged In
              </Button>
              <Button 
                size="sm" 
                variant="outline" 
                onClick={signOut}
                className="border-accent text-accent hover:bg-accent/10"
              >
                <LogOut className="h-3 w-3 mr-1" />
                Sign Out
              </Button>
            </div>
          </div>
        </AlertDescription>
      </Alert>
    </div>
  );
};